import * as React from 'react';
import { withRouter, RouteComponentProps, Redirect } from 'react-router-dom';
import headerLogo from '../images/header-logo.png';
import '../styles/Login.css';
import { PromiseHelper } from '../classes/promiseHelper';
import { LogInResponse } from '../api/dataTypes';
import { confirmAccount } from '../api/api-account';
import TextInput from '../components/text-input';

interface State {
  email: string;
  password: string;
  password2: string;
  message: string;
  isLoggedIn: boolean;
  disableInputs: boolean;
  errorMsg: string;
}

export interface Props extends RouteComponentProps<{}> { }

// This component is linked in the email sent to new users, and password reset emails
// The email will build the url to include the users email and the Identity token
class AccountConfirmPage extends React.Component<Props, State> {
  email: string = '';
  token: string = '';
  loginPromise: PromiseHelper<LogInResponse> = new PromiseHelper();

  constructor(props: Props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      password2: '',
      message: '',
      isLoggedIn: false,
      disableInputs: false,
      errorMsg: '',
    };
  }

  componentWillMount() {
    const params = this.props.location.search;
    let e = params.match(new RegExp('email=(.*)&'));
    let t = params.match(new RegExp('token=(.*)'));

    if (e && t) {
      this.email = e[1];
      this.token = t[1];
    }
  }

  componentDidMount() {
    this.setState({ email: this.email });
  }

  componentWillUnmount() {
    this.loginPromise.clearPromise();
  }

  render() {
    if (this.state.isLoggedIn === true) {
      return <Redirect to={{ pathname: '/' }} />;
    } else {
      return (
        <div
          className="mt-5"
          onKeyPress={this.handleKeyPress}
        >
          <div className='d-flex justify-content-center' >
            <div className="col-lg-6 col-md-10 col-sm-12 login">
              <div className="d-flex justify-content-center">
                <img
                  className=""
                  src={headerLogo}
                  alt='BHS Logo'
                  onClick={this.logoPressed}
                />
              </div>
              <label className="header-text text-center col-12 mb-3 mt-3">
                Please enter your new password:
              </label>
              
              <TextInput
                value={this.state.email}
                handleChange={this.handleInputChange}
                propName='username'
                title='Email'
                class='col-lg-12 col-md-12 mb-5'
                disabled={this.state.disableInputs}
                inputType='email'
              />

              <TextInput
                value={this.state.password}
                handleChange={this.handleInputChange}
                propName='password'
                title='Password'
                class='col-lg-12 col-md-12 mb-3'
                inputType="password"
                disabled={this.state.disableInputs}
              />

              <TextInput
                value={this.state.password2}
                handleChange={this.handleInputChange}
                propName='password2'
                title='Confirm Password'
                class='col-lg-12 col-md-12 mb-3'
                inputType="password"
                disabled={this.state.disableInputs}
              />

              <label className="error-msg text-center col-12">
                {this.state.errorMsg}
              </label>

              {this.renderButton()}

            </div>
          </div>
        </div>
      )
    }
  }

  renderButton = () => {
    return (
      <div className='d-flex justify-content-center'>
        <button
          className="btn button button-action"
          onClick={this.handleLogin}
          disabled={this.state.disableInputs}
        >
          Confirm
        </button>

      </div>
    )
  }

  private handleKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      this.handleLogin();
    }
  }

  private handleInputChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    this.setState({
      ...this.state,
      [e.currentTarget.name]: e.currentTarget.value
    });
  }

  private handleLogin = () => {
    if(!this.state.password) {
      this.setState({ errorMsg: "The password cannot be blank" });
      return;
    } else if (this.state.password !== this.state.password2) {
      this.setState({ errorMsg: "The entered passwords do not match" });
      return;
    }
    this.setState({ disableInputs: true, errorMsg: '' });
    this.loginUser(this.state.email, this.state.password, this.state.password2);
  }

  private loginUser = (email: string, pw: string, pw2: string) => {
    this.loginPromise.newPromise(
      confirmAccount(email, this.token, pw, pw2),
      t => {
        this.setState({
          isLoggedIn: true,
          disableInputs: false
        });
      },
      error => {
        this.setState({ 
          disableInputs: false,
          errorMsg: error.message
        });
      }
    )
  }

  private logoPressed = () => {
    this.setState({ isLoggedIn: true });
  }

}
export default withRouter<Props>(AccountConfirmPage);